import {
	LPView,
	LPGroup,
	LPText,
	LPPageGroup,
	LPTopicRoot,
	LPIcon,
	LPToolbar,
	LPTool,
	LPToolCard,
	LPWidget
} from 'lp-widgets';
import { Glossary } from 'glossary';
import { LearningActivity } from 'learning-activity';
import { RiseActivation } from '@holmescorp/rise-activation';
import { LandingPage } from '@holmescorp/landing-page';
import { RCSCard } from '@holmescorp/lcc-rcs';
import { PracticeCard, PosttestCard } from '@holmescorp/card';
import { Carousel } from '@holmescorp/carousel';
import { CertificateCard } from '@holmescorp/certificate';

import { registry } from 'lcc-state';

import '@holmescorp/quiz-widgets';
import '@holmescorp/cut-scores';
import '@holmescorp/resource-parser';
import '@holmescorp/topic-progress';

export function register_lp_widgets(): void {
	registry.define('LPView', LPView);
	registry.define('PageGroup', LPPageGroup);
	registry.define('Group', LPGroup);
	registry.define('TopicRoot', LPTopicRoot);
	registry.define('Text', LPText);
	registry.define('Icon', LPIcon);
	registry.define('Toolbar', LPToolbar);
	registry.define('Tool', LPTool);
	registry.define('ToolCard', LPToolCard);
	registry.define('Carousel', Carousel);
	registry.define('Widget', LPWidget);
	// widgets loaded via LPWidget
	// registry.define('Breadcrumbs', Breadcrumbs);
	// registry.define('Evaluation', Evaluation);
	// registry.define('ExamCountdown', ExamCountdown);
	registry.define('LearningActivity', LearningActivity);
	registry.define('RiseActivation', RiseActivation);
	registry.define('Glossary', Glossary);
	registry.define('LandingPage', LandingPage);

	// widgets for additional resources carousel
	registry.define('CertificateCard', CertificateCard);
	registry.define('PracticeCard', PracticeCard);
	registry.define('PosttestCard', PosttestCard);
	registry.define('RCSCard', RCSCard);

	registry.define('ResourceCenter', async (): Promise<any> => {
		const { ResourceCenter } = await import('lcc-rcs');
		return ResourceCenter;
	});
	registry.define('Search', async (): Promise<any> => {
		const { Search } = await import('search-widget');
		return Search;
	});
	registry.define('Video', async (): Promise<any> => {
		const { Video } = await import('video');
		return Video;
	});
	registry.define('Certificate', async (): Promise<any> => {
		const { Certificate } = await import('certificate');
		return Certificate;
	});
	// other widgets
	// registry.define('TopRecommended', TopRecommended);
	// registry.define('FirstRecommended', FirstRecommended);
	// registry.define('StudyPlan', StudyPlan);
}
